/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
const counter = () => {
  (($) => {
    $(document.body).on("updated_cart_totals", function (e) {
      console.log(e.type);

      const $cartCountElement = $(".product-quantity input[type='number']");

      let cartCount = 0;

      $cartCountElement.each(($index, $elem) => {
        cartCount += parseInt($elem.value);
      });

      const $cartElement = $(".cart-counter");
      if ($cartElement) {
        $cartElement.text(cartCount);
      }
    });

    $(document.body).on(
      "added_to_cart",
      function (e, fragments, cart_hash, this_button) {
        const addedProductCount = parseInt($(".quantity input").val());

        const $cartElement = $(".cart-counter");
        let cartCount = parseInt($(".cart-counter").first().text());

        if ($cartElement) {
          $cartElement.text(addedProductCount + cartCount);
        }
      }
    );
  })(jQuery);
};

try {
  counter();
} catch (error) {
  console.log(error);
}
